import Divider from "../../component/divider";
import WorkExperienceComponent from "../../component/work_exp_component";

const WorkExperience = ({ workExperience }) => {
    return (
        <div className="work-exp">
            <div className="work-header">
                Working Experience
            </div>
            <div className="content-card">
                {
                    workExperience.map(( exp , index) => {
                        if (index !== workExperience.length -1){
                            return (
                                <>
                                    <WorkExperienceComponent workExperience = {exp} />
                                    <Divider />
                                </>
                            )
                        }
                        return(
                            <WorkExperienceComponent workExperience = {exp} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default WorkExperience;